import { useContext } from 'react';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import { CLAIM_REWARDS_PENDING, REWARDS_CLAIMED } from '../../config/constants';
import appContext from '../../context/app/appContext';
import errorContext from '../../context/error/errorContext';
import modalContext from '../../context/modal/modalContext';
import { formatUSD } from '../../helpers/formats';
import useClaimableStakingRewards from '../../hooks/web3/vault/useClaimableStakingRewards';
import { sleep } from '../../web3/utils';

const ClaimAllStakingRewardsModal: React.FC = () => {
    const { openModal, closeModal, setModalData } = useContext(modalContext);

    const { claimableStakingRewards, updateClaimableStakingRewards } =
        useClaimableStakingRewards();

    const { interfaceSDK, chainConfig } = useContext(appContext);
    const { setError } = useContext(errorContext);

    const onClose = () => closeModal('claimAllStakingRewardsModal');

    const claim = async () => {
        try {
            if (!interfaceSDK || !claimableStakingRewards) return;

            setModalData((prev) => ({ ...prev, message: CLAIM_REWARDS_PENDING }));
            openModal('waitingModal');

            const stakingContract =
                await interfaceSDK.get.getSpoolStakingContractInstance();

            const rewards = await stakingContract.getRewards(
                [chainConfig.spoolToken],
                true
            );

            const receipt = await rewards.wait();

            await sleep(3000);

            await updateClaimableStakingRewards(claimableStakingRewards);

            onClose();
            setModalData((prev) => ({
                ...prev,
                status: REWARDS_CLAIMED,
                txHash: receipt.transactionHash,
                message: '',
            }));
            openModal('successModal');
        } catch (error) {
            setError(error);
        } finally {
            closeModal('waitingModal');
        }
    };

    return (
        <CustomModal
            modalName='claimAllStakingRewardsModal'
            className='claim-all-staking-rewards-modal'
        >
            <CustomModalHeader title='Claim All Rewards' onClose={onClose} />
            <div className='note'>
                Claims ALL your DAO Rewards and $SPOOL/voSPOOL Emission rewards and
                deposits them in your wallet.
            </div>
            <div className='details'>
                <span>Details</span>
                {claimableStakingRewards &&
                Object.keys(claimableStakingRewards).length ? (
                    <>
                        <div className='detail-container'>
                            <div className='name'>Emission Rewards</div>
                            <div className='value'>
                                {formatUSD(
                                    claimableStakingRewards.spoolRewards['SPOOL'] || 0
                                )}{' '}
                                $SPOOL
                            </div>
                        </div>
                        <div className='detail-container'>
                            <div className='name'>voSPOOL Emission Rewards</div>
                            <div className='value'>
                                {formatUSD(
                                    claimableStakingRewards.voSpoolRewards['SPOOL'] || 0
                                )}{' '}
                                $SPOOL
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
            <div className='total'>
                <div className='text'>Total to Claim:</div>
                <div className='available'>
                    <div className='claimable'>
                        {claimableStakingRewards &&
                        Object.keys(claimableStakingRewards).length
                            ? formatUSD(
                                  (claimableStakingRewards?.spoolRewards['SPOOL'] ?? 0) +
                                      (claimableStakingRewards?.voSpoolRewards['SPOOL'] ??
                                          0) || 0
                              )
                            : null}{' '}
                        $SPOOL
                    </div>
                </div>
            </div>
            <Button onClick={claim}>Claim</Button>
        </CustomModal>
    );
};

export default ClaimAllStakingRewardsModal;
